<template>
  <b-modal
    id="annonce-incomplete-modal"
    class="incomplete-full-screen-modal"
    header-class="incomplete-modal-header"
    ref="modal"
    centered
    no-close-on-esc
    no-close-on-backdrop
  >

    <template #modal-header="{ close }">
      <div  class="incomplete-modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/img-watcher-right.png`)" class="incomplete-modal-img" >
        <div class="incomplete-container h-100">
          <h1 class="page-title mt-4 ml-4 incomplete-modal-subtitle">{{$t('annonce.incomplete.modal.title')}}</h1>
        </div>
      </div>
    </template>

    <div>
      <p class="modal-annonce-text mt-2" v-html="$t('annonce.incomplete.modal.text')"></p>

      <b-form-checkbox
        class="mt-3"
        id="needsReminderNotification"
        v-model="annonce.needsReminderNotification">
        <span class="custom-span-checkbox">{{ $t('annonce.incomplete.modal.notif') }}</span>
      </b-form-checkbox>

      <p class="modal-annonce-text-offline" v-html="$t('annonce.incomplete.modal.wait.text')"></p>
    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button  class="w-100 mr-2" variant="secondary"  @click="handleOk($event)" :disabled="isLoading">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('annonce.incomplete.modal.publish')}}</span>
          </div>
        </b-button>
        <b-button  class="w-100" variant="primary"  @click="handleCancel" :disabled="isLoading">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('annonce.incomplete.modal.complete')}}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
    };
  },

  props:{
    annonce: {
      required:true,
      type : Object,
    },
  },

  emits: [
    'checkedNotif', 'publish', 'complete'
  ],

  methods: {
    getRemainingTime() {
      // if (this.annonce !== null && this.annonce.status === "TO_VALIDATE" && this.annonce.lastStatusDate !== null) {
      //
      // }
      return "48h"
    },

    async handleOk(e) {
      this.isLoading = true
      e.preventDefault()
      this.$emit('publish', this.annonce)
      this.isLoading = false
    },

    handleCancel(){
      this.isLoading = true
      this.$emit('complete', this.annonce)
      this.isLoading = false
    }
  },
};
</script>

<!-- not scoped car modal --><style>

.modal-annonce-text-offline{
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  margin-top: 2em;
}


.custom-span-checkbox{
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: var(--main-grey-medium);
}

#annonce-incomplete-modal .modal-header{
  background-color: var(--main-black-light) !important;
  padding-bottom: 0px;
}

#annonce-incomplete-modal .modal-content,
#annonce-incomplete-modal .modal-body,
#annonce-incomplete-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.incomplete-modal-subtitle{
  font-size: 24px;
}

.incomplete-modal-img{
  max-width: 200px;
}
#annonce-incomplete-modal .incomplete-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}


.incomplete-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#annonce-incomplete-modal .modal-annonce-text{
  color: var(--main-grey-medium);
}

.incomplete-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.incomplete-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  .incomplete-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .incomplete-container img {
    order: 2;
    align-self: center;
  }
  .incomplete-container {
    text-align: center;
  }
}

#annonce-incomplete-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.incomplete-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.incomplete-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #annonce-incomplete-modal .modal-content {
    display: flex;
    overflow: auto;
  }
  #annonce-incomplete-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-incomplete-modal .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #annonce-incomplete-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #annonce-incomplete-modal .modal-header {
    padding-top: 0px;
  }
  .incomplete-modal-img {
    margin-top: 20px;
    align-self: end;
  }
  .incomplete-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0px !important;
  }
  #annonce-incomplete-modal .modal-content {
    margin: 8px;
  }
  #annonce-incomplete-modal .modal-annonce-text, #annonce-incomplete-modal .incomplete-container {
    padding: 10px;
  }
  #annonce-incomplete-modal .incomplete-modal-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #annonce-incomplete-modal .modal-content {
    overflow: auto;
  }
  .title-step4{
    font-size: 24px!important;
  }

  .incomplete-modal-subtitle{
    font-size: 18px;
  }
  .incomplete-modal-header-content, #annonce-incomplete-modal .modal-annonce-text, .incomplete-container {
    padding: 2px;

  }
}





</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceIncompleteModal.vue